/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-30 10:04:39
 * @LastEditors: K
 * @LastEditTime: 2022-10-08 16:28:36
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import {
  AddOrEditMemberCardFnParams,
  bindMemberFn,
  BindMemberParams,
  deleteMemberCardFn,
  DeleteMemberCardParams,
  EditMemberCardParams,
  getAddMemberCardFn,
  getAddMembersFn,
  getAddMembersFnParams,
  getAddMembersOperationFn,
  getEditMemberCardDetailFn,
  getEditMemberCardFn,
  getMemberCardListFn,
  getMemberCardSearchListFn,
  getMembersBaseInfoFn,
  getMembersBaseInfoFnParams,
  getMembersDetailFn,
  getMembersInfoFn,
  getMembersPageFn,
  getMembersPageFnParams,
  getMembersTopUpFn,
  getMembersTopUpFnParams,
  getMembersTopUpRecordFn,
  getMembersTopUpRecordFnParams,
  getSearchMembersByCardNoFn,
  getSearchMembersFn,
  getSearchMembersFnParams,
  MemberCardListParams,
  unbindMemberCardFn,
  UnbindMemberCardParams,
} from '../../services/members'

//  会员管理-列表
export const getMembersPage = createAsyncThunk<
  any,
  getMembersPageFnParams,
  RootThunkApi
>('members/getMembersPage', async (params, api) => {
  return sendAsync(getMembersPageFn(params), api)
})
//  会员管理-新增
export const getAddMembers = createAsyncThunk<
  any,
  getAddMembersFnParams,
  RootThunkApi
>('members/getAddMembers', async (params, api) => {
  return sendAsync(getAddMembersFn(params), api)
})
//  会员管理-详情
export const getMembersDetail = createAsyncThunk<
  void,  
  any,
  RootThunkApi
>('members/getMembersDetail', async (params, api) => {
  return sendAsync(getMembersDetailFn(params), api)
})
//  会员管理-新增会员-操作人
export const getAddMembersOperation = createAsyncThunk<any, void, RootThunkApi>(
  'members/getAddMembersOperation',
  async (_, api) => {
    return sendAsync(getAddMembersOperationFn(), api)
  }
)
//  会员管理-会员基础信息
export const getMembersBaseInfo = createAsyncThunk<
  any,
  getMembersBaseInfoFnParams,
  RootThunkApi
>('members/getMembersBaseInfo', async (params, api) => {
  return sendAsync(getMembersBaseInfoFn(params), api)
})
//  会员管理-充值 or 退款详情信息
export const getMembersInfo = createAsyncThunk<
  any,
  getMembersBaseInfoFnParams,
  RootThunkApi
>('members/getMembersInfo', async (params, api) => {
  return sendAsync(getMembersInfoFn(params), api)
})
//  会员管理-充值 or 退款
export const getMembersTopUp = createAsyncThunk<
  any,
  getMembersTopUpFnParams,
  RootThunkApi
>('members/getMembersTopUp', async (params, api) => {
  return sendAsync(getMembersTopUpFn(params), api)
})
//  会员管理-充值记录
export const getMembersTopUpRecord = createAsyncThunk<
  any,
  getMembersTopUpRecordFnParams,
  RootThunkApi
>('members/getMembersTopUpRecord', async (params, api) => {
  return sendAsync(getMembersTopUpRecordFn(params), api)
})
//  药品零售-搜索会员
export const getSearchMembers = createAsyncThunk<
  any,
  getSearchMembersFnParams,
  RootThunkApi
>('members/getSearchMembers', async (params, api) => {
  return sendAsync(getSearchMembersFn(params), api)
})

// 会员管理-搜索会员-通过会员卡号
export const getSearchMembersByCardNo = createAsyncThunk<
  any,
  getSearchMembersFnParams,
  RootThunkApi
>('members/getSearchMembersByCardNo', async (params, api) => {
  return sendAsync(getSearchMembersByCardNoFn(params), api)
})

// 会员卡新增
export const getAddMemberCard = createAsyncThunk<
  any,
  AddOrEditMemberCardFnParams,
  RootThunkApi
>('members/getAddMemberCard', async (params, api) => {
  return sendAsync(getAddMemberCardFn(params), api)
})

// 会员卡编辑
export const getEditMemberCard = createAsyncThunk<
  any,
  AddOrEditMemberCardFnParams,
  RootThunkApi
>('members/getEditMemberCard', async (params, api) => {
  return sendAsync(getEditMemberCardFn(params), api)
})

// 会员卡编辑详情
export const getEditMemberCardDetail = createAsyncThunk<
  void,
  EditMemberCardParams,
  RootThunkApi
>('members/getEditMemberCardDetail', async (params, api) => {
  return sendAsync(getEditMemberCardDetailFn(params), api)
})

// 会员卡删除
export const deleteMemberCard = createAsyncThunk<
  any,
  DeleteMemberCardParams,
  RootThunkApi
>('members/deleteMemberCard', async (params, api) => {
  return sendAsync(deleteMemberCardFn(params), api)
})

// 会员卡解绑
export const unbindMemberCard = createAsyncThunk<
  any,
  UnbindMemberCardParams,
  RootThunkApi
>('members/unbindMemberCard', async (params, api) => {
  return sendAsync(unbindMemberCardFn(params), api)
})

// 会员卡绑定
export const bindMember = createAsyncThunk<
  any,
  BindMemberParams,
  RootThunkApi
>('members/bindMember', async (params, api) => {
  return sendAsync(bindMemberFn(params), api)
})



// 会员卡列表
export const getMemberCardList = createAsyncThunk<
  any,
  MemberCardListParams,
  RootThunkApi
>('members/getMemberCardList', async (params, api) => {
  return sendAsync(getMemberCardListFn(params), api)
})

// 会员卡搜索下拉
export const getMemberCardSearchList = createAsyncThunk<
  any,
  MemberCardListParams,
  RootThunkApi
>('members/getMemberCardSearchList', async (params, api) => {
  return sendAsync(getMemberCardSearchListFn(params), api)
})
